import { GLProbe } from './GLProbe';

/**
 * WebGL probe for Node.js runtime.
 *
 * @todo GL rendering in node is possible:
 * - https://github.com/stackgl/headless-gl
 * - https://github.com/akira-cn/node-canvas-webgl
 *
 * @remarks
 * In a typical Node.js environment there is no browser WebGL context,
 * therefore this probe always reports "not supported".
 * If needed, WebGL in Node can be implemented with headless-gl or similar libs.
 */
export class NodeGLProbe extends GLProbe {
  /**
   * No-op in Node.js.
   *
   * @override
   */
  queryWebGL(): void {
    this.version = undefined;
    // noop
  }

  /**
   * Always returns `false` in Node.js implementation.
   *
   * @override
   */
  isSupported(): boolean {
    return false;
  }
}
